import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    addToast: (state, action) => {
      const { id, message, type = "info", duration = 2800 } = action.payload;
      let randomId = id;
      if (!randomId) {
        randomId = Math.random().toString(36).slice(2);
      }
      state.items.push({ id: randomId, message, type, duration });
    },
    removeToast: (state, action) => {
      const id = action.payload;
      state.items = state.items.filter((t) => t.id !== id);
    },
    clearToasts: (state) => {
      state.items = [];
    },
  },
});

export const { addToast, removeToast, clearToasts } = toastSlice.actions;
export default toastSlice.reducer;
